import PropertyGrid from "@/components/PropertyGrid";
import { useNavigate } from "react-router-dom";
import { properties } from "@/data/properties";
import Header from "@/components/Header";
import { usePublishedProperties } from "@/hooks/usePublishedProperties";

const Terrenos = () => {
  const navigate = useNavigate();
  const publishedProperties = usePublishedProperties();
  const allProperties = [...publishedProperties, ...properties];
  const terrenos = allProperties.filter((property) => property.type === "terreno");

  return (
    <>
      <Header />
      <div className="w-full pt-24">
        <button
          type="button"
          onClick={() => navigate("/")}
          aria-label="Volver al inicio"
          className="fixed right-4 top-20 z-40 flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-sm font-black text-slate-600 shadow-sm"
        >
          X
        </button>
        <div className="mx-auto max-w-7xl px-4">
          <PropertyGrid
            properties={terrenos}
            loading={false}
            selectedCategory="terreno"
            showCategories={false}
            onCategoryChange={() => {}}
            onPropertyClick={(property) => navigate(`/propiedad/${property.id}`)}
            title="Terrenos Comerciales"
            subtitle="Ideales para tu proximo gran proyecto"
          />
        </div>
      </div>
    </>
  );
};

export default Terrenos;
